/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { TextField, TextFieldProps } from 'src/js/components/form/TextField';

export function FileField(props: TextFieldProps) {
  const [inputValue, setInputValue] = useState('');

  const fileRef = useRef<HTMLInputElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const openFileDUpload = () => {
    fileRef.current.click();
    inputRef.current.blur();
  }

  const handleUpload = () => {
    props.input.onChange(fileRef.current.files[0])
    fileRef.current.value = null;
  }

  useEffect(() => {
    if (props.input?.value?.name) {
      setInputValue(`${props.input.value?.name}`)
    }
  }, [props.input?.value])

  const propsOverride = {
    input: {
      ...props.input,
      value: inputValue,
      onChange: () => undefined,
      onBlur: () => undefined,
      onClick: openFileDUpload,
      ref: inputRef
    }
  }

  return <>
    <input type="file" ref={fileRef} onChange={handleUpload} style={{ display: 'none' }}/>
    <TextField {...props} {...propsOverride} />
  </>
}